module.exports = __webpack_public_path__ + "static/media/appstrax.9722f49e.png";